import { Form } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Load } from "../load/load";
import { eliminarCargos } from "../../api/cargos";
import { toast } from "react-toastify";
import queryString from "query-string";
import { LogsInformativos } from "../logs/logs";

export default function EliminarCargos({ data, history, setShow }) {

    const idDocumental = data[0];

    const dataTemp = {
        nombre: data[1],
        descripcion: data[2],
    };

    const [formData, setFormData] = useState(initialFormValue(dataTemp));

    //load
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simula una carga de datos
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, []);

    //insert
    const onSubmit = (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            // Sube a cloudinary la imagen principal del producto

            eliminarCargos(idDocumental).then((response) => {
                const { data } = response;
                //notificacion
                LogsInformativos("Se ha eliminado el cargo " + idDocumental)
                toast.success(data.mensaje);

                history({
                    search: queryString.stringify(""),
                });
                setLoading(false);
                setShow(false);
                //cancelarRegistro()
            });
        } catch (e) {
            console.log(e);
        }
    };

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <>
            {loading && <Load />}
            <div className='generalDoctores'>
                <Form className='formDoctores' onSubmit={onSubmit} onChange={onChange}>
                    <Form.Group className='datosPersonalesDoc'>
                        <Form.Label className='lblpApellido'>Nombre: </Form.Label>
                        <Form.Control
                            type='text'
                            className='inpPrimerADoc'
                            placeholder='Ingresa primer apellido'
                            value={formData.nombre}
                            name="nombre"
                            disabled
                        />
                        <Form.Label className='lblsApellido'>Descripcionn: </Form.Label>
                        <Form.Control
                            type='text'
                            className='inpSegundoA'
                            placeholder='Ingresa el nombre del departamento'
                            defaultValue={formData.descripcion}
                            name="descripcion"
                            disabled
                        />
                    </Form.Group>
                    <br />
                    <label></label>
                    <div className="divSubmit">
                        <input className="submit" value="Enviar" type="submit" />
                    </div>
                </Form>
            </div>
        </>
    );
}

function initialFormValue(data) {
    return {
        nombre: data.nombre,
        descripcion: data.descripcion,
    };
}
